import * as ko from 'knockout'
import { Params, RaceFinisherViewModel } from './RaceFinisherViewModel'
import template from './race.finisher.tpl.html'

if (!ko.components.isRegistered('race-finisher')) {
  ko.components.register('race-finisher', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new RaceFinisherViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
